import ROUTE_NAME from "@/router/router.const";
import InvitePage from "@/modules/invite/InviteSuccess.page.vue";

export default {
  path: "/invite/:code",
  name: ROUTE_NAME.INVITE_PAGE,
  component: InvitePage,
};
